function toCamelCase(str) {
  return str.replace(/-([a-z])/g, function (_, letter) { return letter.toUpperCase() })
}

function normalizeObjectKeys(obj) {
  if (!obj || typeof obj !== 'object') return {}
  return Object.keys(obj).reduce(function (acc, key) {
    acc[toCamelCase(key)] = obj[key]
    return acc
  }, {})
}

function toPositiveInteger(value) {
  var n = Number(value)
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : null
}

function parseStepPosition(value) {
  var n = Number(value)
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : null
}

function pickFirstDefined() {
  for (var i = 0; i < arguments.length; i++) {
    if (arguments[i] !== undefined && arguments[i] !== null && arguments[i] !== '') return arguments[i]
  }
  return null
}

export { normalizeObjectKeys, toPositiveInteger, parseStepPosition, pickFirstDefined }
